var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"actions"},[_c(_setup.ElevatorTroubleLogCreate,{ref:"elevatorTroubleLogCreateRef",attrs:{"color":"primary"},on:{"log-added":_setup.logAdded}})],1),_c(_setup.ElevatorTroubleLogTable,{ref:"elevatorTroubleLogTableRef",on:{"on-edit":_setup.onEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }